import { React } from "react";
import TabHeader from "../TabHeader";
import WelcomePost from "../../Posts/WelcomePost/WelcomePost";

const DashboardContent = (props) => {
  return (
    <section className="dashboard-tab">
      <TabHeader tabHeaderTitle="Dashboard" />
      <WelcomePost userName={props.userName} />
    </section>
  );
};

export default DashboardContent;
